import React from 'react';
import styled, { css } from 'styled-components';

import { Nullable } from '@tager/web-core';
import { SvgComponent } from '@tager/web-components';

import { ReactComponent as Delivery } from '@/assets/svg/delivery.svg';
import { ReactComponent as Wallet } from '@/assets/svg/wallet.svg';
import { ReactComponent as Size } from '@/assets/svg/size.svg';
import { colors } from '@/constants/theme';

enum Icon {
  DELIVERY = 'delivery',
  WALLET = 'wallet',
  SIZE = 'size',
}

function getIconElement(icon: string): Nullable<SvgComponent> {
  return icon === Icon.DELIVERY
    ? StyledDelivery
    : icon === Icon.WALLET
    ? StyledWallet
    : icon === Icon.SIZE
    ? StyledDSize
    : null;
}

type Props = {
  icon: string;
  note: string;
  text?: string;
  textButton?: boolean;
  hasColor?: boolean;
  fontWeight: string | number;
  marginTop?: number;
  onClick?: () => void;
};

function TextWithIcon({
  icon,
  text,
  textButton,
  note,
  hasColor,
  fontWeight,
  marginTop,
  onClick,
}: Props) {
  const IconElement = getIconElement(icon);

  return (
    <Component marginTop={marginTop} onClick={onClick}>
      {IconElement && <IconElement />}
      <TextWrapper>
        <Note highlighted={!!hasColor} weight={fontWeight}>
          {note}
        </Note>
        {text ? (
          textButton ? (
            <TextButton>{text}</TextButton>
          ) : (
            <Text>{text}</Text>
          )
        ) : null}
      </TextWrapper>
    </Component>
  );
}

export default TextWithIcon;

const Component = styled.div<{ marginTop?: number }>`
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${marginTop}px;
    `}
  display: flex;
  align-items: center;
`;
const TextWrapper = styled.div``;
const Note = styled.div<{ highlighted: boolean; weight: string | number }>`
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
  ${({ highlighted, weight }) =>
    highlighted
      ? css`
          font-weight: ${weight};
          color: ${colors.primary};
        `
      : css`
          font-weight: ${weight};
          color: ${colors.black};
        `}
`;

const Text = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;
const TextButton = styled.button`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  color: ${colors.primary};
`;

const marginRight14 = css`
  margin-right: 14px;
`;

const marginRight10 = css`
  margin-right: 14px;
`;

const StyledWallet = styled(Delivery)`
  ${marginRight14}
`;
const StyledDelivery = styled(Wallet)`
  ${marginRight14}
`;
const StyledDSize = styled(Size)`
  ${marginRight10}
`;
